// @need-translate
import router from 'next/router';
import {stringify} from 'qs';
import {openWindow} from '../common/openWindow.function';
import {requestContext} from '../common/requestContext';
import {SelfCertRequestParams} from '../selfCert/SelfCertRequestParams.interface';

export function processSelfCertRequest({
  selfCertRequestParams,
}: {
  selfCertRequestParams: SelfCertRequestParams;
}) {
  const pageProcessId = Math.floor(new Date().getTime() / 1000); // unix time
  const authPath = `/auth/id/verify/start?process_id=${pageProcessId}&${stringify(
    selfCertRequestParams
  )}`;

  if (requestContext.requestInfo.display.isWebView) {
    router.push(authPath);
  } else {
    openWindow({
      url: `https://${window.location.host}${authPath}`,
      target: '연령인증',
      features: 'width=360,height=800',
    });
  }
}
